module.exports = "/_next/static/images/italian-20472fd37ca2f17bf630f654c944316c.jpg";